// ClickUp F-CU16a — the "Longbox 1 · Press E to open" hint is a function of TWO facts, not one: which
// box the crosshair is on, AND whether that box is already open. It used to be pushed only when the
// HOVER changed (longbox-lid `commitHover`), and the hover dispatcher only runs while the pointer is
// locked — so opening a box (which frees the cursor for the browse pose, and in Studio Play) never
// took the hint down: Shaun's report picture, "Press E to open" over a box standing open.
//
// PURE so the rule is tested as written; the stage evaluates it every frame and emits only on change.

/** Box states in which the ACTIVE box is open — or moving, so "open it" is not a true prompt. */
export const BOX_OPEN_STATES = Object.freeze(["opening", "open", "browsing", "hero", "closing"]);

/**
 * @param {{hoveredBoxId: string|null, activeBoxId: string|null, boxState: string, name?: string|null}} s
 * @returns {{id: string, name: string}|null} what the hint should show, or null for hidden
 */
export function boxHintFor({ hoveredBoxId, activeBoxId, boxState, name }) {
	if (!hoveredBoxId) return null;
	if (hoveredBoxId === activeBoxId && BOX_OPEN_STATES.includes(boxState)) return null;
	return { id: hoveredBoxId, name: name || hoveredBoxId };
}

/** Change key — the stage emits only when this differs from the last emitted one. */
export const boxHintKey = (h) => (h ? `${h.id}|${h.name}` : "");
